import { render, staticRenderFns } from "./zuiming.vue?vue&type=template&id=d29bea9e&scoped=true&"
import script from "./zuiming.vue?vue&type=script&lang=js&"
export * from "./zuiming.vue?vue&type=script&lang=js&"
import style0 from "./zuiming.vue?vue&type=style&index=0&id=d29bea9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29bea9e",
  null
  
)

export default component.exports